module.exports = "/_next/static/images/88dbb46ca874e1fbbcf949a51308791a-people-working-together@md-1x.jpg.webp";